import React from 'react';
import { Radio, Slider } from 'antd';
import './SingleLayerSettingsH3.css';
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { HexagonIcon } from "../core/customIcons";


export function SingleLayerSettingsH3({

    data,
    setData,
    zoom,
    setZoom,
    color,
    setColor,
    height,
    setHeight

}) {
    const marks = {
        4: <HexagonIcon className='z4' />,
        5: <HexagonIcon className='z5' />,
        6: <HexagonIcon className='z6' />,
        7: <HexagonIcon className='z7' />
    }
    const ZoomOptions = { 4: 'z4', 5: 'z5', 6: 'z6', 7: 'z7' }
    const HeightOptions = [{
        label: 'average building height [m]',
        value: 'avg_building_height'
    }, { label: 'total building area [m²]', value: 'building_area' }, {
        label: 'total population',
        value: 'population'
    }, { label: 'number of residential building', value: 'num_res_buildings' }, {
        label: 'number of buildings',
        value: 'num_buildings'
    }]
    const ColorOptions = ['earthquake', 'flash-flood', 'flood', 'landslide', 'tsunami', 'volcanic']

    function onchangeZoom(e) {
        const selectedZoom = ZoomOptions[e]
        setZoom(selectedZoom)
        setData({
            ...data,
            geoserver_layer_name: 'h3-' + selectedZoom + '-indonesia',
            id: selectedZoom === 'z4' ? 60 : selectedZoom === 'z5' ? 65 : selectedZoom === 'z6' ? 66 : selectedZoom === 'z7' ? 67 : 60
        })
    }

    function IncrementZoom() {
        if (zoom === 'z7') {
            return
        } else {
            let idx = parseInt(getValueFromZoom(ZoomOptions, zoom))
            let selectedZoom = ZoomOptions[idx + 1]
            setZoom(selectedZoom)
            setData({
                ...data,
                geoserver_layer_name: 'h3-' + selectedZoom + '-indonesia',
                id: selectedZoom === 'z4' ? 60 : selectedZoom === 'z5' ? 65 : selectedZoom === 'z6' ? 66 : selectedZoom === 'z7' ? 67 : 60
            })
        }

    }

    function DecrementZoom() {
        if (zoom === 'z4') {
            return
        } else {
            let idx = parseInt(getValueFromZoom(ZoomOptions, zoom))
            let selectedZoom = ZoomOptions[idx - 1]
            setZoom(selectedZoom)
            setData({
                ...data,
                geoserver_layer_name: 'h3-' + selectedZoom + '-indonesia',
                id: selectedZoom === 'z4' ? 60 : selectedZoom === 'z5' ? 65 : selectedZoom === 'z6' ? 66 : selectedZoom === 'z7' ? 67 : 60
            })
        }
    }

    const getValueFromZoom = (object, zoomValue) => {
        return Object.keys(object).find(key => object[key] === zoomValue);
    }

    const onChangeHeight = ({ target: { value } }) => {
        setHeight(value)
    }

    const onChangeColor = ({ target: { value } }) => {
        setColor(value)
    }

    return (
        <>
            <p style={{ marginTop: '0' }}>Select hexagon dimension:</p>
            <div className='sliderGroup'>
                <PlusCircleOutlined className='zoomIcon' onClick={DecrementZoom} />
                <Slider className='slider' value={getValueFromZoom(ZoomOptions, zoom)} onChange={onchangeZoom}
                    marks={marks} min={4} max={7} step={1} />
                <MinusCircleOutlined className='zoomIcon' onClick={IncrementZoom} />
            </div>
            <p>Select height variable (exposure):</p>
            <Radio.Group className='radio-vertical' options={HeightOptions} onChange={onChangeHeight} value={height} />
            <p>Select color variable (hazard):</p>
            <Radio.Group className='radio-vertical' options={ColorOptions} onChange={onChangeColor} value={color} />
        </>
    )
}